// extracted by css-extract-rspack-plugin
export default {"errorBox":"ModelPersistenceLogJobs-module__errorBox___IO2jc"};